module.exports = __webpack_public_path__ + "static/img/0000志愿者2.ac39eca.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/0000志愿者2.jpg
// module id = vqzG
// module chunks = 0